module.exports = __webpack_public_path__ + "static/media/syncui_128.38fd7d49.ico";